import { EmptyState, PageHead } from '@hive/ui';
import { Link, useLocation } from 'react-router';
import { useI18nP, type PlatformKey } from '../i18n';
import { autonomousHref, useScreenCatalog, type AutonomousScreen } from '../lib/screens';

/** Texto de uma via de saída (bus:<categoria>, api, api:alerts.close, obj:<arquivo>, gap, none). */
function feedText(t: (k: PlatformKey, v?: Record<string, string>) => string, f: string): string {
  const [kind, arg] = f.split(':', 2);
  if (kind === 'bus') return t('auto.feed.bus', { c: arg ?? '' });
  if (f === 'api:alerts.close') return t('auto.feed.alertsClose');
  if (kind === 'api') return t('auto.feed.api');
  // obj:<arquivo>: vai no retrato diário do armazenamento de objetos da conexão "Autonomous"
  if (kind === 'obj') return t('autonomous.feed.obj', { f: arg ?? '' });
  if (kind === 'gap') return t('auto.feed.gap');
  return t('auto.feed.none');
}

/**
 * Tela que o Autonomous assumiu (integração ligada na implantação). O menu já não a mostra; isto cobre links
 * guardados, atalhos e a busca: diz quem cuida agora e por onde os dados dela saem do Hive.
 */
export function AutonomousManaged({ screen }: { screen: AutonomousScreen }) {
  const { t, has } = useI18nP();
  const name = has(screen.nav) ? t(screen.nav as PlatformKey) : screen.nav;
  // com hive.autonomous.url configurada: o mesmo objeto (alerta, CVE, vulnerabilidades do ativo) no Autonomous
  const loc = useLocation();
  const href = autonomousHref(useScreenCatalog(), loc.pathname + loc.search);
  return (
    <>
      <PageHead title={name} />
      <EmptyState
        title={t('auto.title')}
        action={
          <>
            {href && (
              <a className="btn btn-primary" href={href} target="_blank" rel="noopener noreferrer" title={t('autonomous.openHint')}>
                {t('autonomous.open')}
              </a>
            )}
            <Link className="btn" to="/">
              {t('notFound.home')}
            </Link>
          </>
        }
      >
        <p>{t('auto.text', { screen: name })}</p>
        <p className="xs muted">{t('auto.feeds')}</p>
        <ul className="xs" style={{ textAlign: 'left', display: 'inline-block', margin: 0 }}>
          {screen.feeds.map((f) => (
            <li key={f}>{feedText(t, f)}</li>
          ))}
        </ul>
      </EmptyState>
    </>
  );
}
